module.exports = __webpack_public_path__ + "static/fond-top-7fa5f797f6569daa0d31dd8a9e786e06.jpg";